import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { MutationOptions } from '@/api/react-query'
import { CreateSessionResponse, ValidateSignupBody } from '@/types'

export async function validateSignup(body: ValidateSignupBody) {
  const response = await httpClient('user-manager').post<CreateSessionResponse>(
    '/v1/signup/validate',
    body,
    { ignoreErrorToast: true },
  )

  return response.data
}

export function useValidateSignup(
  options?: MutationOptions<CreateSessionResponse, ValidateSignupBody>,
) {
  return useMutation({
    mutationFn: validateSignup,
    ...options,
  })
}
